export default "__VITE_ASSET__561f00c7__"